import { Heading } from "../Type";
import styles from "./index.module.scss";

type PropsType = {
  title: string;
};

const SectionHeading = ({ title }: PropsType) => {
  return (
    <div className={styles.container}>
      <Heading size="h4">{title}</Heading>
    </div>
  );
};

export default SectionHeading;
